// extracted by mini-css-extract-plugin
export default {"Loader":"Spinner_Loader__banow","load6":"Spinner_load6__MCXHv","round":"Spinner_round__IYPi8"};